import { useEffect } from 'react';

import { QuestionSelector } from 'pages/custom_tests/components/custom_test_wizard/components/question_selector/QuestionSelector';
import { useCustomTestWizard } from 'pages/custom_tests/components/custom_test_wizard/context';

export const QuestionsStep = () => {

    const { fetchQuestions, focusObjectiveId, handleQuestionsChange, loadingQuestions, minutes, mode, questionIds, questionTree, setProviderState, settingsSeen } = useCustomTestWizard();

    useEffect(() => {

        fetchQuestions();

    }, []);

    return (
        <QuestionSelector
            focusObjectiveId={focusObjectiveId}
            loading={loadingQuestions}
            minutes={minutes}
            onChange={handleQuestionsChange}
            onFocusHandled={() => setProviderState({ focusObjectiveId: 0 })}
            questionTree={questionTree}
            richSummary={false}
            selectedIds={questionIds}
            showActualTime={mode === 'edit' || settingsSeen}
        />
    );

};
